<template>
    <el-form ref="form" :model="form" label-width="10%" >

    <div>

        <div  style="height:  300px;  ">
            <el-amap class="amap-box" vid="amap"
                     :zoom="form.zoom"
                     :center="form.center"
                     :plugin="form.plugin">

                <el-amap-marker vid="marker"
                                :position="form.center"
                                :label="form.label"
                >

                </el-amap-marker>
                <el-amap-circle  vid="circle"
                                 :center="form.center"
                                 :radius="form.radius"
                                 fill-opacity="0.2"
                                 strokeColor="#38f"
                                 strokeOpacity="0.8"
                                 strokeWeight="1"
                                 fillColor="#38f"
                >

                </el-amap-circle>

            </el-amap>

        </div>
    </div>


    <el-form-item label="创建人" style="margin-top: 20px">
        <span style="color: dodgerblue">{{obj.alias}}</span>
    </el-form-item>

    <el-form-item label="报修日期" style="margin-top: 20px">
        <div class="block">
            <el-date-picker disabled
                            v-model="form.date"
                            type="datetime"
                            placeholder="选择日期">
            </el-date-picker>
        </div>
    </el-form-item>

    <el-form-item label="派单日期">
        <div class="block">
            <el-date-picker disabled
                            v-model="form.dispatch_date"
                            type="datetime"
                            placeholder="选择日期">
            </el-date-picker>
        </div>
    </el-form-item>

    <el-form-item label="完工日期">
        <div class="block">
            <el-date-picker disabled
                            v-model="form.completedDate"
                            type="datetime"
                            placeholder="选择日期">
            </el-date-picker>
        </div>
    </el-form-item>

        <el-form-item label="服务厂商"  >
            <el-select v-model="form.account_id" clearable filterable placeholder="请选择"  disabled
                       style="width: 82%">
                <el-option
                        v-for="item in form.providerArray"
                        :key="item.account_id"
                        :label="item.provider_name"
                        :value="item.account_id">
                    <span style="float: left">{{ item.provider_name }}</span>
                </el-option>
            </el-select>
        </el-form-item>



        <!--<el-form-item label="抄送人员">-->
        <!--<el-select v-model="form.ccUser" multiple clearable filterable placeholder="请选择"-->
                   <!--style="width: 100%">-->
            <!--<el-option-->
                    <!--v-for="item in form.cc_list"-->
                    <!--:key="item.user_id"-->
                    <!--:label="item.alias"-->
                    <!--:value="item.user_id">-->
                <!--<span style="float: left">{{ item.alias}}</span>-->
            <!--</el-option>-->
        <!--</el-select>-->
    <!--</el-form-item>-->

    <!--<el-form-item label="备注">-->
        <!--<el-input-->
                <!--type="textarea"-->
                <!--:autosize="{ minRows: 4, maxRows: 10}"-->
                <!--placeholder="请输入备注信息"-->
                <!--v-model="form.comments">-->
        <!--</el-input>-->

    <!--</el-form-item>-->
</el-form>
</template>

<script>
    import http from '../../../APIService/http'

    export default {
        props: {
//            form: {
//                type: Object,
//                default: () => {
//                }
//            },
//            obj: {
//                type: Object,
//                default: () => {
//                }
//
//            }
        },
        components: {},
        data() {
            return {
                form: {
                   linked_tenant : '',
                    linked_store : '',
                    account_id : '',
                    providerArray : [],

                    date: "",
                    dispatch_date: "",
                    completedDate: "",
                    comments: "",
                    ccUser: [],
                    cc_list: [],


                    lng: 0,
                    lat: 0,
                    loaded: false,
                    plugin: [
                        {
                            locate : true,
                            enableHighAccuracy: true,//是否使用高精度定位，默认:true
                            timeout: 100,          //超过10秒后停止定位，默认：无穷大
                            maximumAge: 0,           //定位结果缓存0毫秒，默认：0
                            convert: true,           //自动偏移坐标，偏移后的坐标为高德坐标，默认：true
                            showButton: true,        //显示定位按钮，默认：true
                            buttonPosition: 'RB',    //定位按钮停靠位置，默认：'LB'，左下角
                            showMarker: true,        //定位成功后在定位到的位置显示点标记，默认：true
                            showCircle: true,        //定位成功后用圆圈表示定位精度范围，默认：true
                            panToLocation: true,     //定位成功后将定位到的位置作为地图中心点，默认：true
                            zoomToAccuracy: true,//定位成功后调整地图视野范围使定位位置及精度范围视野内可见，默认：f
                            extensions: 'all',
                            pName: 'ToolBar',
                            events: {
                                init(o) {
                                    // o 是高德地图定位插件实例
//                                    o.getCurrentPosition((status, result) => {
//                                        console.log(result)
//                                        if (result && result.position) {
//                                            self.lng = result.position.lng;
//                                            self.lat = result.position.lat;
//                                            self.center = [self.lng, self.lat];
//                                            self.loaded = true;
//                                            self.$nextTick();
//                                        }
//                                    });
                                }
                            }
                        }],
                    zoom: 8,
                    center: [116.46, 39.92],
                    markers: [
                        {
                            position: [116.46, 39.92],
                            visible: true,
                            template: '1'
                        }
                    ],
                    radius:100,
                    label:{
                        content:'',
                        offset:[10,12]
                    },
                },
                obj: {
//                    initiator: "RETAIL"
                    initiator: "SERVICE",
                    created_by: "",
                    account_name: "",
                    store_name: "",
                    alias: "",
                    ticket_id: '',
                    ticket_no: "",
                    phone: "",
                    photo: [],
                    status: "NEW",
                    stepDatas: [{title: "已接单"},
                        {title: "已派单"},
                        {title: "进行中"},
                        {title: "已完工"},
                        {title: "已评价"}],
                    reference_obj : ''

                },
            }
        },
        computed: {},
        created() {

        },
        methods: {
            getObj(data){
                this.obj = data
            },

            setInfo(data){
                this.form.date = data.date
                this.form.dispatch_date = data.dispatch_date
                this.form.center = data.center
                this.form.lng = data.lng
                this.form.lat = data.lat
                this.form.zoom = data.zoom
                this.form.markers[0].position = data.position
                this.form.label.content = data.content
                this.form.comments = data.comments
                this.form.ccUser = data.ccUser
                this.form.linked_tenant = data.linked_tenant
                this.form.linked_store = data.linked_store
                this.form.account_id = data.account_id

                this.getServiceProviderList()
            },

            async getServiceProviderList() {


                let data = {
                    tenant_id: this.form.linked_tenant,
                    store_id: this.form.linked_store
                }
                try {

                    this.form.providerArray = []
                    await http.post('/wapi/v1/getServiceProviderList', data).then(res => {
                        if (res.success) {
                            this.form.providerArray = res.data
                        }
                    })

                } catch (err) {
                    this.error()
                }

            },

            setCompletedDate(data){
                this.form.completedDate = data
            },

            setCCList(data){
                this.form.ccUserArray = []
                this.form.cc_list = data
            }


        }
    }
</script>

<style lang="scss" module>
    @import '../../../assets/css/default';
</style>



// WEBPACK FOOTER //
// src/pages/serviceWorkOrder/form/secondForm.vue